import color from "color";
import styled from "styled-components";
import { LinkItem, LinkTitle } from "../LeftMenu/LeftMenu.styles";

// NavFooter is 100% wide with 8px side padding, so a full-width row lines up
// with the nav rows above.
export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  min-width: 0;
`;

// A nav row (icon, hover, active colours) that shares the footer with the
// logout button. These rules come after LinkItem's, so width: auto also
// overrides its width: 100% under the sm breakpoint.
export const SettingsLink = styled(LinkItem)`
  flex: 1 1 auto;
  min-width: 0;
  width: auto;
`;

export const FooterName = styled(LinkTitle)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

// A square as tall as the settings row beside it, so the two controls read as
// one band: the row is LinkItem's 22px icon plus its vertical padding, which
// drops at the sm breakpoint.
export const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  border-radius: 7px;
  transition: background-color 0.2s;
  flex-shrink: 0;

  ${({ theme }) => theme.sm`
    width: 38px;
    height: 38px;
  `}

  svg {
    fill: ${({ theme }) => color(theme.grey).darken(0.35).hex()};
    width: 18px;
    height: 18px;
    transition: fill 0.2s;
    path {
      fill: ${({ theme }) => color(theme.grey).darken(0.35).hex()};
    }
  }

  &:hover {
    background-color: ${({ theme }) => theme.subtleHover};

    svg {
      fill: ${({ theme }) => theme.primary};
      path {
        fill: ${({ theme }) => theme.primary};
      }
    }
  }
`;
